import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core';
import { TalkingPointsContext } from '..';
import { skins } from '../skins';
import { COLOR_GREY_SHADOW } from '../../colors';
const { white } = skins;
const {
    LR_LOGO_PATH,
    EQUAL_HOUSING_LOGO_PATH,
} = white;
const COPYRIGHT_YEAR = new Date().getFullYear();

const useStyles = makeStyles(()=> ({
    container: {
        position: 'relative',
        width: '100%',
        height: '100%',
        fontSize: '24px',
    },
    buttonContainer: {
        position: 'absolute',
        left: 64,
        top: 220,
        marginTop: 'auto',
        marginBottom: 'auto',
    },
    customButton: {
        background: '#8551DC',
        color: '#fff',
        width: '380px',
        height: '70px',
        borderRadius: '8px',
        borderColor: 'transparent',
        fontSize: '28px',
        fontWeight: '700',
        lineHeight: '20px',
        textAlign: 'center',
        boxShadow: '4px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    },
    userProfileContainer: {
        position: 'absolute',
        left: 56,
        top: 360,
        width: 500,
        height: 126,
        padding: '16px 16px 16px 0',
        lineHeight: '1.4em',
        display: 'flex',
        gap: '16px',
        alignItems: 'center',
        textAlign: 'left',
        boxSizing: 'border-box',
    },
    userName: {
        fontWeight: 900,
        lineHeight: '32px',
    },
    headshot: {
        minWidth: 96,
        height: 96,
        borderRadius: '50%',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
    },
    imagesWrapper: {
        position: 'absolute',
        width: 450,
        height: 328,
        top: 182,
        right: 0,
    },
    imagesContainer: {
        position: 'relative',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
    },
    imageWrap: {
        position: 'absolute',
        width: 385,
        height: '100%',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
    },
    image0: {
        width: '308px',
        height: '206px',
        right: 28,
        top: 0,
        boxShadow: '4px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    },
    image1: {
        width: '312px',
        height: '186px',
        right: 82,
        top: 98,
        boxShadow: '4px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    },
    image2: {
        width: '308px',
        height: '202px',
        right: 14,
        top: 158,
        border: `0.5px solid ${COLOR_GREY_SHADOW}`,
        boxShadow: '4px 4px 4px 0px rgba(0, 0, 0, 0.25)'
    },
    disclaimer: {
        fontFamily: ['"LL Circular Pro"', 'Arial', 'Helvetica', 'sans-serif'],
        position: 'absolute',
        left: 60,
        bottom: 16,
        textAlign: 'left',
        fontSize: '16px',
        lineHeight: '20px',
        color: '#fff',
    },
    equalHousingLogo: {
        marginLeft: 12,
    },
    disclaimerCopyright: {
        marginTop: 4,
    },
    dateContainer: {
        position: 'absolute',
        bottom: 30,
        right: 64,
        textAlign: 'right',
        fontSize: '24px',
        lineHeight: '32px',
        fontWeight: 600,
        color: '#fff',
    },
}));

export const White = ()=> {
    const {
        user: {
            name,
            headshot,
        } = {},
        images,
        dateStr,
    } = useContext(TalkingPointsContext);
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <div className={classes.buttonContainer}>
                <button className={classes.customButton}>See the full report</button>
            </div>
            <div className={classes.userProfileContainer}>
                {headshot && (
                    <div className={classes.headshot}
                        style={{backgroundImage: `url("${headshot}")`}}
                    ></div>
                )}
                {name && (
                    <div className={classes.userProfileName}>
                        Brought to you by<br/>
                        <div className={classes.userName}>{name}</div>
                    </div>
                )}
            </div>
            <div className={classes.imagesWrapper}>
                <div className={classes.imagesContainer}>
                    {(images.length > 1 && images[0]?.length) && (<div className={`${classes.imageWrap} ${classes.image0}`} style={{
                        backgroundImage: `url("${images[0]}")`,
                    }}></div>)}

                    {(images.length > 0 && images[1]?.length) && (<div className={`${classes.imageWrap} ${classes.image1}`} style={{
                        backgroundImage: `url("${images[1]}")`,
                    }}></div>)}

                    {(images.length > 2 && images[2]?.length) && (<div className={`${classes.imageWrap} ${classes.image2}`} style={{
                        backgroundImage: `url("${images[2]}")`,
                    }}></div>)}
                </div>
            </div>

            <div className={classes.disclaimer}>
                <div>
                    <img src={LR_LOGO_PATH} height={20} alt="ListReports" />
                    <img className={classes.equalHousingLogo} src={EQUAL_HOUSING_LOGO_PATH} height={20} alt="Equal Housing Opportunity" />
                </div>
                <div className={classes.disclaimerCopyright}>
                    &copy; ListReports {COPYRIGHT_YEAR}, all rights reserved.
                </div>
            </div>

            <div className={classes.dateContainer}>
                {dateStr}
            </div>
        </div>
    );
};
